export class Excepcion {
	mensaje = 'Error no especificado';
	
	constructor(mensaje) {
		this.mensaje = (mensaje !== undefined) ? mensaje : this.mensaje;
	}
	
	toString() {
		return this.mensaje;
	}
}

export class ErrorNotificacion extends Excepcion {
	constructor() {
		let mensaje = 'Error al mostrar notificación';
		super(mensaje);
	}
}

export class RechazoNotificaciones extends Excepcion {
	constructor() {
		let mensaje = 'No se permitieron las notificaciones';
		super(mensaje);
	}
}

export class ErrorRegistroServiceWorker extends Excepcion {
	constructor() {
		let mensaje = 'Error al registrar Service Worker';
		super(mensaje);
	}
}

export class ErrorDatosIoT extends Excepcion {
	constructor() {
		let mensaje = 'Error al obtener datos para suscribirse a IoT';
		super(mensaje);
	}
}

export class ErrorInstanciacion extends Excepcion {
	constructor(nombreClase) {
		let mensaje = `La clase '${nombreClase}' no puede instanciarse`;
		super(mensaje);
	}
}

export class MetodoNoImplementado extends Excepcion {
	constructor(nombreMetodo, nombreClase) {
		let mensaje = `El método '${nombreMetodo}' de la clase '${nombreClase}' no está implementado`;
		super(mensaje);
	}
}

export class NoHayRegistroServiceWorker extends Excepcion {
	constructor() {
		let mensaje = 'No hay registro de Service Worker';
		super(mensaje);
	}
}

export class WindowNoTieneAndroid extends Excepcion {
	constructor() {
		let mensaje = 'Objeto window no tiene valor para Android';
		super(mensaje);
	}
}
